export default function Pagenotfound404(){
    return <p className="pnf">404 <span style={{ fontSize: "3.5vw" }}>|</span> Not Found</p>
}